import React, { useState } from "react";
import styled from "styled-components";
import { FiMoreVertical, FiFilter } from "react-icons/fi";

const issuesData = [
  {
    id: 1,
    poster: "John Doe",
    image: "https://i.pravatar.cc/150?img=1",
    description: "Getting TypeError on login in React app. Need urgent help.",
    codeImage: "https://via.placeholder.com/300x100?text=Code+Snippet",
    reward: "₹500",
    type: "Paid",
    tech: ["React", "Firebase", "Auth"],
  },
  {
    id: 2,
    poster: "Priya Singh",
    image: "https://i.pravatar.cc/150?img=5",
    description: "Facing issue with async await in Node.js route handler.",
    codeImage: "",
    reward: "Free",
    type: "Free",
    tech: ["Node.js", "Express"],
  },
  // Add more mock issues...
];

const Wrapper = styled.div`
  display: flex;
  background: #0b0b0b;
  color: white;
  min-height: 100vh;
`;

const Sidebar = styled.div`
  width: 250px;
  padding: 1rem;
  background: #111;
  border-right: 1px solid #222;
  @media (max-width: 768px) {
    display: ${(props) => (props.open ? "block" : "none")};
    position: absolute;
    z-index: 999;
    height: 100%;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 1rem;
`;

const FilterToggle = styled.div`
  display: none;
  padding: 1rem;
  background: #111;
  cursor: pointer;
  border-bottom: 1px solid #222;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  border: none;
  background: #1a1a1a;
  color: white;
  margin-bottom: 1rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
`;

const Card = styled.div`
  background: #1a1a1a;
  padding: 1rem;
  border-radius: 16px;
  box-shadow: 0 0 0 1px #222;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const PosterInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Poster = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

const PosterImg = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;

const TechTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const Tag = styled.span`
  background: #333;
  padding: 0.3rem 0.7rem;
  border-radius: 12px;
  font-size: 12px;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 1rem;
`;

const PageButton = styled.button`
  background: ${(props) => (props.active ? "#00ffcb" : "#222")};
  color: ${(props) => (props.active ? "#000" : "#fff")};
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
`;

export default function IssuesPage() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [search, setSearch] = useState("");

  const filteredIssues = issuesData.filter((issue) =>
    issue.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Wrapper>
      <Sidebar open={showSidebar}>
        <h3>Filters</h3>
        <p>Tech Stack</p>
        <Tag>React</Tag>
        <Tag>Node.js</Tag>
        <Tag>MongoDB</Tag>
        <Tag>Next.js</Tag>
        <hr />
        <p>Type</p>
        <Tag>Free</Tag>
        <Tag>Paid</Tag>
        <hr />
        <p>Posted Time</p>
        <Tag>Last 24h</Tag>
        <Tag>Last Week</Tag>
      </Sidebar>

      <Content>
        <FilterToggle onClick={() => setShowSidebar(!showSidebar)}>
          <FiFilter /> Filters
        </FilterToggle>

        <SearchInput
          placeholder="Search issues..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Grid>
          {filteredIssues.map((issue) => (
            <Card key={issue.id}>
              <PosterInfo>
                <Poster>
                  <PosterImg src={issue.image} />
                  <strong>{issue.poster}</strong>
                </Poster>
                <FiMoreVertical size={20} />
              </PosterInfo>

              <p>
                {issue.description.length > 100
                  ? issue.description.substring(0, 100) + "..."
                  : issue.description}
              </p>

              {issue.codeImage && (
                <img
                  src={issue.codeImage}
                  style={{ width: "100%", borderRadius: "10px" }}
                  alt="Code"
                />
              )}

              <TechTags>
                {issue.tech.map((tech) => (
                  <Tag key={tech}>{tech}</Tag>
                ))}
              </TechTags>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tag>{issue.type}</Tag>
                <Tag>{issue.reward}</Tag>
              </div>

              <button
                style={{
                  marginTop: "0.5rem",
                  padding: "0.5rem",
                  background: "#00ffcb",
                  borderRadius: "10px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Chat with Poster
              </button>
            </Card>
          ))}
        </Grid>

        <Pagination>
          <PageButton active>1</PageButton>
          <PageButton>2</PageButton>
          <PageButton>3</PageButton>
        </Pagination>
      </Content>
    </Wrapper>
  );
}
